import type { Mutation } from 'vuex'
import type { ApiKeyDetails } from '@/api/api_key/apiKeyModel'

import actionTypes from './actionTypes'
import { State } from './state'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  [actionTypes.SET_MODAL_CONFIRM_API_KEY_ACTIVED]: (state: State, boolean: boolean) => {
    state.modalConfirmApiKeyActived = boolean
  },
  [actionTypes.SET_API_KEY_DATAS]: (state: State, data: Array<ApiKeyDetails>) => {
    state.apiKeyDatas = data
  },
}

export default mutations
